import * as React from 'react'

export const OrderConfirmationContext = React.createContext({
  skipBasketReset: () => {},
})

export const useOrderConfirmation = () => React.useContext(OrderConfirmationContext)
